import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/css/Careers.css";

export const Careers = ({ data }) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("open");
  const [jobs, setJobs] = useState([]);
  const [openJobs, setOpenJobs] = useState([]);
  const [closedJobs, setClosedJobs] = useState([]);

  useEffect(() => {
    if (data && data.length > 0) {
      const now = new Date();
      const updatedJobs = data.map(job => {
        const deadlineDate = parseDeadline(job.deadline);
        return {
          ...job,
          deadlineDate,
          isOpen: deadlineDate > now
        };
      });

      setJobs(updatedJobs);
      setOpenJobs(updatedJobs.filter(job => job.isOpen));
      setClosedJobs(updatedJobs.filter(job => !job.isOpen));
    }
  }, [data]);

  const parseDeadline = (deadlineString) => {
    // Example format: "29th of November 2024."
    const parts = deadlineString.split(' ');
    const day = parseInt(parts[0]);
    const month = parts[2];
    const year = parseInt(parts[3].replace('.', ''));
    
    const monthMap = {
      January: 0, February: 1, March: 2, April: 3, May: 4, June: 5,
      July: 6, August: 7, September: 8, October: 9, November: 10, December: 11
    };
    
    return new Date(year, monthMap[month], day, 23, 59, 59);
  };

  const CountdownTimer = ({ deadline }) => {
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(deadline));

    useEffect(() => {
      const timer = setInterval(() => {
        setTimeLeft(calculateTimeLeft(deadline));
      }, 1000);

      return () => clearInterval(timer);
    }, [deadline]);

    function calculateTimeLeft(endDate) {
      const now = new Date();
      const difference = endDate - now;

      if (difference <= 0) {
        return { expired: true };
      }

      return {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
        expired: false
      };
    }

    if (timeLeft.expired) {
      return <span className="expired-timer">Closed</span>;
    }

    return (
      <div className="countdown-timer">
        {timeLeft.days}d {timeLeft.hours}h {timeLeft.minutes}m {timeLeft.seconds}s
      </div>
    );
  };

  return (
    <div className="careers-page">
      <div className="hero-section">
        <div className="hero-text">
          <h1>WE ENRICH YOUR LIFE</h1>
          <p>
            At Deft Technologies, we are driven by a passion for innovation and
            excellence, committed to helping businesses across Africa unlock
            the full potential of Microsoft Dynamics 365. Our team thrives on
            delivering impactful solutions that foster efficiency and growth.
            Joining Deft means becoming part of a dynamic, results-oriented
            company where your contributions matter.
          </p>
        </div>
      </div>

      <div className="careers-content container">
        <div className="latest-jobs">
          <h2>LATEST JOBS</h2>
          <p className="sub-title">
            Join our team and help us deliver the best solutions for our clients.
          </p>

          <div className="jobs-tabs">
            <button
              className={`tab-button ${activeTab === 'open' ? 'active' : ''}`}
              onClick={() => setActiveTab('open')}
            >
              Open Positions ({openJobs.length})
            </button>
            <button
              className={`tab-button ${activeTab === 'closed' ? 'active' : ''}`}
              onClick={() => setActiveTab('closed')}
            >
              Closed Positions ({closedJobs.length})
            </button>
          </div>

          {jobs.length > 0 ? (
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>Job Title</th>
                    <th>Description</th>
                    <th>{activeTab === 'open' ? 'Time Remaining' : 'Closed On'}</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {(activeTab === 'open' ? openJobs : closedJobs).map((job) => (
                    <tr key={job.id}>
                      <td>{job.title}</td>
                      <td>{job.description.substring(0, 50)}...</td>
                      <td>
                        {activeTab === 'open' ? (
                          <CountdownTimer deadline={job.deadlineDate} />
                        ) : (
                          job.deadline
                        )}
                      </td>
                      <td>
                        <button
                          className="view-more-btn"
                          onClick={() => navigate(`/careers/${job.id}`)}
                        >
                          View More
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="no-jobs">
              There are no vacancies available at the moment. Keep checking our
              site for new job openings.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};